<!-- 资源管理-音频管理-音频列表-详情/审核-内容-吴影茹 -->
<template>
  <div class="video_detail">
    <!-- 基础信息 -->
    <a-descriptions bordered :column="24" :labelStyle="{ width: '180px' }" :contentStyle="{ width: '300px' }">
      <a-descriptions-item label="音频标题" :span="24">{{ info.title }}</a-descriptions-item>
      <a-descriptions-item label="章节信息" :span="24">{{ info.textbookGroupName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="简介" :span="24">{{ info.intro || '-' }}</a-descriptions-item>
      <a-descriptions-item label="状态" :span="12" v-if="type == 'detail'">
        <a-tag :color="info.status == 1 ? 'success' : 'default'">{{
          statusList.find((item) => {
            return item.value == info.status
          })?.label || '-'
        }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="附件" :span="type == 'detail' ? 12 : 24">
        <div class="link_text" @click="previewAudio">点击播放音频</div>
      </a-descriptions-item>
      <a-descriptions-item label="知识点" :span="24">
        <div class="row_wrap" style="gap: 15px" v-if="info.knowledge && info.knowledge.length != 0">
          <div class="resource_knowledge_item" v-for="(item, index) in info.knowledge" :key="index">{{ item }}</div>
        </div>
        <div v-else>-</div>
      </a-descriptions-item>
    </a-descriptions>
    <!-- 练习信息 -->
    <a-descriptions layout="vertical" bordered :column="24" :labelStyle="{ width: '180px' }" :contentStyle="{ width: '300px' }">
      <!-- 习题 -->
      <a-descriptions-item label="课后练习-习题" :span="24">-</a-descriptions-item>
    </a-descriptions>
    <!-- 其他信息 -->
    <a-descriptions bordered :column="24" :labelStyle="{ width: '180px' }" :contentStyle="{ width: '300px' }">
      <a-descriptions-item label="辅助素材包" :span="24">
        <div>
          <div class="row_wrap" style="gap: 15px; margin-bottom: 20px">
            <a-image v-for="(item, index) in info.packageImgs" :key="index" style="width: 200px; height: 130px" :src="item" />
          </div>
          <div class="column_start" style="gap: 10px">
            <div v-for="(item, index) in info.packageFiles" :key="index" @click="downUrl(item.fileUrl)" class="link_text">{{ item.fileName }}</div>
          </div>
        </div>
      </a-descriptions-item>
      <a-descriptions-item label="创建人" :span="12">{{ info.createBy }}</a-descriptions-item>
      <a-descriptions-item label="创建时间" :span="12">{{ info.createTime }}</a-descriptions-item>
      <a-descriptions-item label="审核人员" :span="12" v-if="info.reviewer && type != 'check' && type != 'previewDetail'">{{
        info.reviewer
      }}</a-descriptions-item>
      <a-descriptions-item label="审核时间" :span="12" v-if="info.reviewTime && type != 'check' && type != 'previewDetail'">{{
        info.reviewTime
      }}</a-descriptions-item>
      <a-descriptions-item label="审核备注" :span="24" v-if="info.reviewer && type != 'check' && type != 'previewDetail'">{{
        info.remark || '-'
      }}</a-descriptions-item>
      <a-descriptions-item label="浏览量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.viewCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="收藏量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.collectCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="分享量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.shareCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="点赞量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.likeCount || 0
      }}</a-descriptions-item>
      <a-descriptions-item label="下载量" :span="12" v-if="type == 'detail' || type == 'previewDetail'">{{
        info.downloadCount || 0
      }}</a-descriptions-item>
    </a-descriptions>
    <!-- 审核 -->
    <div v-if="type == 'check'">
      <OyForm
        ref="checkFormRef"
        :schema="formSchema"
        v-model="form"
        layout="horizontal"
        labelAlign="right"
        :labelCol="{ style: { width: '70px' } }"
        style="margin-top: 20px"
      >
      </OyForm>
      <div class="row_center_center">
        <a-button type="primary" style="width: 200px" @click="submitHandler" :loading="checkLoading">提交</a-button>
      </div>
    </div>

    <!-- 预览音频 -->
    <AudioModal v-model:visible="previewVisible" :url="previewUrl" />
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { AudioDetailInfo } from './types'
import { useRouter } from 'vue-router'
import { useDict } from '@/composable/useDict'
const { getDictData } = useDict()
const router = useRouter()
import * as api from './service'
import { message } from 'ant-design-vue'

const props = defineProps({
  id: {
    type: String,
    default: ''
  },
  //   detail普通详情  check审核   rejectDetail拒绝详情   previewDetail预览详情
  type: {
    type: String,
    default: 'detail'
  }
})

onMounted(async () => {
  await getStatusList()
  getDetail()
})
const emit = defineEmits(['submit'])

const info = ref<AudioDetailInfo>({
  videoId: '',
  title: '',
  attachUrl: ''
})

const getDetail = async () => {
  // 获取基础信息
  await api.audioDetail(props.id).then((res) => {
    info.value = { ...res.data }
    info.value.textbookGroupName = res.data.textbook.textbookGroupName
    // 试题
    // 试卷
    // 辅助素材包
    if (res.data.materialUrl && res.data.materialUrl != '') {
      info.value.packageList = JSON.parse(res.data.materialUrl)

      var imgs: any = []
      var files: any = []

      info.value.packageList.map((item) => {
        if (item.fileUrl) {
          var lastIndex1 = item.fileUrl.lastIndexOf('.')
          var str1 = item.fileUrl.substring(lastIndex1 + 1)
          if (str1 == 'png' || str1 == 'jpeg' || str1 == 'jpg') {
            imgs.push(item.fileUrl)
          } else {
            files.push({ ...item })
          }
        }
      })

      info.value.packageImgs = imgs
      info.value.packageFiles = files
    }
  })
}

// 状态列表
const statusList = ref<any>([])
// 获取状态列表
const getStatusList = async () => {
  statusList.value = await getDictData('resource_status_manage')
}

// 播放音频
const previewVisible = ref(false)
const previewUrl = ref('')
const previewAudio = () => {
  previewVisible.value = true
  previewUrl.value = info.value.attachUrl
}

// 下载素材包
const downUrl = (url) => {
  window.open(url)
}

// 审核
const form = ref<any>({
  reviewStatus: 1,
  remark: ''
})
const formSchema = ref<any>([
  {
    type: 'radio',
    colSpan: 24,
    label: '结果',
    field: 'reviewStatus',
    required: true,
    ruleText: '请选择结果',
    props: {
      options: [
        { value: 1, label: '通过' },
        { value: 2, label: '不通过' }
      ]
    }
  },
  {
    type: 'textarea',
    colSpan: 24,
    label: '备注',
    field: 'remark',
    required: true,
    props: {
      rows: 4
    },
    showWhen: (model) => form.value.reviewStatus == 2
  },
  {
    type: 'textarea',
    colSpan: 24,
    label: '备注',
    field: 'remark',
    props: {
      rows: 4
    },
    showWhen: (model) => form.value.reviewStatus == 1
  }
])

const checkFormRef = ref<any>(null)
const checkLoading = ref(false)

// 提交审核
const submitHandler = () => {
  checkFormRef.value.validate().then((valid) => {
    checkLoading.value = true

    api
      .audioReview({
        videoId: props.id,
        reviewStatus: form.value.reviewStatus,
        remark: form.value.remark
      })
      .then((res) => {
        message.success('操作成功')
        checkLoading.value = false
        resetHandler()
        emit('submit')
      })
      .catch(() => {
        checkLoading.value = false
      })
  })
}

// 重置
const resetHandler = () => {
  form.value = {
    reviewStatus: 1,
    remark: ''
  }
  checkFormRef.value.reset()
}
</script>
            
<style lang="scss" scoped>
.video_detail {
  ::v-deep(.oy_table_content) {
    padding: 0px;
  }
}
</style>